(function () {
  'use strict';

  // Constants
  const STEP = 5;
  const MIN_Q = STEP;
  const CLICK_DELAY = 350;
  const DEBOUNCE_DELAY = 300;

  // Selectors
  const sel = {
    price: '.price, .price-item, .product__price',
    priceContainer: '.price__container, .product__price',
    cartRow: '.cart__row, .cart-item, [data-cart-item]',
    cartUnitPrice: '.cart__price, .cart-item__price',
    cartLinePrice: '.cart-item__line-price, [data-line-price]',
    cartTotal: '.cart__grand-total, .order-summary__total, [data-cart-total]',
    quantityInput: 'input[name="quantity"], input[name="updates[]"], .quantity__input',
    plusBtn: '.quantity__button--plus, [data-action="increase"], [name="plus"], .js-qty__adjust--plus',
    minusBtn: '.quantity__button--minus, [data-action="decrease"], [name="minus"], .js-qty__adjust--minus',
    addToCartForm: 'form[action*="/cart/add"], form[action*="/cart/add.js"]'
  };

  function throttle(fn, delay) {
    let last = 0;
    return function (...args) {
      const now = Date.now();
      if (now - last >= delay) {
        last = now;
        fn(...args);
      }
    };
  }

  function debounce(fn, delay) {
    let timer;
    return function (...args) {
      clearTimeout(timer);
      timer = setTimeout(() => fn(...args), delay);
    };
  }

  function getNumber(text) {
    let cleaned = text
      .replace(/\s/g, '')
      .replace(/(\d)[., ](?=\d{3}\b)/g, '$1')
      .replace(',', '.')
      .replace(/[^\d.]/g, '');
    return parseFloat(cleaned) || 0;
  }

  function getAvailableStock(input) {
    const stockAttr = input.getAttribute('data-inventory');
    return stockAttr ? parseInt(stockAttr, 10) || Infinity : Infinity;
  }



  

function initProductPrice() {
  if (!window.location.pathname.includes('/products/')) return;
  const qtyInput = document.querySelector(sel.quantityInput);
  const priceItem = document.querySelector('.price-item'); 
  const priceEl = priceItem?.closest('.price'); 
  if (!priceEl || !priceItem || !qtyInput) return;
  const textPrice = getNumber(priceItem.textContent);
  priceEl.dataset.price = textPrice.toFixed(2);   
  const unit = parseFloat(priceEl.dataset.price);
  const stock = getAvailableStock(qtyInput);
  const init = parseInt(qtyInput.value, 10) || MIN_Q;
  qtyInput.value = Math.max(MIN_Q, Math.floor(Math.min(init, stock) / STEP) * STEP);
  const container = priceItem.parentElement;
  let totalEl = document.querySelector('.qty-total-price');
  if (!totalEl) {
    totalEl = document.createElement('div');
    totalEl.className = 'qty-total-price';
    container.insertAdjacentElement('afterend', totalEl);
  }
  if (!document.querySelector('.qty-multiple-note')) {
    const noteEl = document.createElement('div');
    noteEl.className = 'qty-multiple-note';
    noteEl.textContent = `This product is available only in multiples of ${STEP}.`;
    container.insertAdjacentElement('afterend', noteEl);
  }
  const update = throttle(() => {
    let q = parseInt(qtyInput.value, 10) || MIN_Q;
    const stock = getAvailableStock(qtyInput);
    q = Math.max(MIN_Q, Math.floor(Math.min(q, stock) / STEP) * STEP);
    qtyInput.value = q;

    const total = (unit * q).toFixed(2);
    const sym = (priceItem.textContent.match(/[$€£¥₽]/) || [''])[0];
    totalEl.textContent = `(${sym}${total} for ${q} items)`;
  }, 100);
  ['input', 'change'].forEach(evt => qtyInput.addEventListener(evt, update));
  update();
}



  
  
  function attachCartListeners() {
    document.body.addEventListener(
      'input',
      throttle(e => {
        const input = e.target.closest(sel.quantityInput);
        if (!input || window.location.pathname.includes('/products/')) return;
        const row = input.closest(sel.cartRow);
        if (!row) return;

        let v = parseInt(input.value, 10) || 0;
        const stock = getAvailableStock(input);
        v = Math.max(MIN_Q, Math.floor(Math.min(v, stock) / STEP) * STEP);
        input.value = v;

        const unitEl = row.querySelector(sel.cartUnitPrice);
        const unit = getNumber(unitEl.textContent);
        const lineEl = row.querySelector(sel.cartLinePrice);
        const newTotal = ((Math.round(unit * 100) * v) / 100).toFixed(2);
        const sym = (unitEl.textContent.match(/[$€£¥₽]/) || [''])[0];
        lineEl.textContent = `${sym}${newTotal}`;

        recalcCartTotal();
      }, 200),
      false
    );
  }

  function recalcCartTotal() {
    let sum = 0;
    document.querySelectorAll(sel.cartRow).forEach(row => {
      const lineEl = row.querySelector(sel.cartLinePrice);
      if (lineEl) sum += Math.round(getNumber(lineEl.textContent) * 100);
    });
    const totalEl = document.querySelector(sel.cartTotal);
    if (totalEl) {
      const sym = (totalEl.textContent.match(/[$€£¥₽]/) || [''])[0];
      totalEl.textContent = `${sym}${(sum / 100).toFixed(2)}`;
    }
  }

  function initManualNormalize() {
    document.querySelectorAll(sel.quantityInput).forEach(input => {
      if (input.dataset.norm) return;
      input.dataset.norm = '1';
      input.addEventListener(
        'change',
        debounce(e => {
          let v = parseInt(e.target.value, 10) || 0;
          const stock = getAvailableStock(e.target);
          e.target.value = Math.max(MIN_Q, Math.floor(Math.min(v, stock) / STEP) * STEP);
        }, DEBOUNCE_DELAY)
      );
    });
  }

  function initQuantityButtons() {
    let lastClickPlus = 0;
    let lastClickMinus = 0;

    document.body.addEventListener(
      'click',
      function (e) {
        const plus = e.target.closest(sel.plusBtn);
        const minus = e.target.closest(sel.minusBtn);
        if (!plus && !minus) return;
        e.preventDefault();
        e.stopImmediatePropagation();

        const now = Date.now();
        if (plus) {
          if (now - lastClickPlus < CLICK_DELAY) return;
          lastClickPlus = now;
        } else {
          if (now - lastClickMinus < CLICK_DELAY) return;
          lastClickMinus = now;
        }

        const anchor = plus || minus;
        const container = anchor.closest(sel.cartRow) || anchor.closest(sel.priceContainer) || document;
        const input = container.querySelector(sel.quantityInput);
        if (!input) return;

        const raw = parseInt(input.value, 10) || 0;
        const stock = getAvailableStock(input);
        let c;
        if (plus) {
          const base = Math.max(MIN_Q, Math.floor(raw / STEP) * STEP);
          c = base + STEP;
        } else {
          const peak = Math.max(MIN_Q, Math.ceil(raw / STEP) * STEP);
          c = Math.max(MIN_Q, peak - STEP);
        }
        c = Math.min(c, Math.floor(stock / STEP) * STEP);

        input.value = c;
        input.dispatchEvent(new Event('input', { bubbles: true }));
      },
      false
    );
  }

  function initFormIntercept() {
    document.querySelectorAll(sel.addToCartForm).forEach(f => {
      if (f.dataset.int) return;
      f.dataset.int = '1';
      f.addEventListener('submit', function (e) {
        const i = this.querySelector(sel.quantityInput);
        if (!i) return;
        let v = parseInt(i.value, 10) || 0;
        const stock = getAvailableStock(i);
        const maxAllowed = Math.floor(stock / STEP) * STEP;
        v = Math.max(MIN_Q, Math.min(v, maxAllowed));
        if (v % STEP !== 0) {
          e.preventDefault();
          i.value = v;
          setTimeout(() => this.submit(), 200);
        }
      });
    });
  }

  function init() {
    initProductPrice();
    attachCartListeners();
    recalcCartTotal();
    initManualNormalize();
    initQuantityButtons();
    initFormIntercept();

    new MutationObserver(
      debounce(() => {
        initProductPrice();
        recalcCartTotal();
      }, DEBOUNCE_DELAY)
    ).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
